var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "57px",
    height: "50px",
    viewBox: "0 0 56 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 25 L 42 25 L 42 47 L 9 47 Z M 9 25 "
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(0.0146796,0.0324987,-0.0362991,0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 12 L 56 12 L 56 47 L 27 47 Z M 27 12 "
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(0.0146796,0.0324987,0.0362991,-0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 L 28 0 L 28 38 L 9 38 Z M 9 0 "
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(-0.0146796,-0.0324987,-0.0362991,0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 0 L 56 0 L 56 26 L 13 26 Z M 13 0 "
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(-0.0146796,-0.0324987,0.0362991,-0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 25 L 42 25 L 42 47 L 9 47 Z M 9 25 "
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(0.0146796,0.0324987,-0.0362991,0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 12 L 56 12 L 56 47 L 27 47 Z M 27 12 "
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(0.0146796,0.0324987,0.0362991,-0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 L 28 0 L 28 38 L 9 38 Z M 9 0 "
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(-0.0146796,-0.0324987,-0.0362991,0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  })), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 0 L 56 0 L 56 26 L 13 26 Z M 13 0 "
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.875 1.710938 C 35.773438 -3.132812 49.316406 2.660156 54.125 14.640625 C 58.929688 26.625 53.183594 40.265625 41.285156 45.109375 C 34.921875 47.695312 28.09375 47.246094 22.378906 44.433594 L 45.996094 34.824219 C 47.175781 34.34375 47.324219 32.722656 46.25 32.035156 L 43.421875 30.214844 C 42.996094 29.941406 42.464844 29.894531 41.996094 30.085938 L 16.609375 40.414062 C 15.046875 38.925781 13.671875 37.203125 12.546875 35.273438 L 33.8125 26.617188 C 34.921875 26.167969 35.136719 24.679688 34.199219 23.925781 L 31.742188 21.957031 C 31.300781 21.601562 30.703125 21.515625 30.183594 21.730469 L 10.238281 29.84375 C 9.632812 27.714844 9.339844 25.554688 9.339844 23.417969 L 37.28125 12.046875 C 38.460938 11.566406 38.605469 9.949219 37.535156 9.261719 L 34.703125 7.441406 C 34.277344 7.167969 33.746094 7.117188 33.277344 7.308594 L 10.335938 16.644531 C 12.304688 10.097656 17.089844 4.472656 23.875 1.710938 Z M 23.875 1.710938 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientTransform: "matrix(-0.0146796,-0.0324987,0.0362991,-0.0131542,27.899907,25.003215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(51.764706%,37.254902%,94.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41.176471%,21.960784%,93.72549%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 27.898438 25.003906 L 41.851562 55.890625 L 7.398438 68.375 L -6.554688 37.488281 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 27.898438 25.003906 L 41.851562 55.890625 L 76.304688 43.402344 L 62.351562 12.519531 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 27.898438 25.003906 L 13.949219 -5.882812 L -20.503906 6.601562 L -6.554688 37.488281 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 27.898438 25.003906 L 13.949219 -5.882812 L 48.402344 -18.367188 L 62.351562 12.519531 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 27.898438 25.003906 L 41.851562 55.890625 L 7.398438 68.375 L -6.554688 37.488281 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 27.898438 25.003906 L 41.851562 55.890625 L 76.304688 43.402344 L 62.351562 12.519531 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 27.898438 25.003906 L 13.949219 -5.882812 L -20.503906 6.601562 L -6.554688 37.488281 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 27.898438 25.003906 L 13.949219 -5.882812 L 48.402344 -18.367188 L 62.351562 12.519531 Z M 27.898438 25.003906 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,66.666669%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 0 27.175781 L 37.28125 12.046875 L 24.863281 20.625 C 24.820312 20.65625 24.796875 20.667969 24.777344 20.683594 C 24.753906 20.695312 24.734375 20.707031 24.714844 20.71875 C 24.6875 20.730469 24.664062 20.738281 24.617188 20.757812 L 11 26.300781 C 10.9375 26.324219 10.902344 26.339844 10.871094 26.347656 C 10.839844 26.359375 10.8125 26.367188 10.78125 26.371094 C 10.746094 26.378906 10.710938 26.378906 10.644531 26.386719 Z M 0 27.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,66.666669%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 5.164062 38.21875 L 33.8125 26.617188 L 25.1875 33.460938 C 25.132812 33.5 25.109375 33.519531 25.082031 33.539062 C 25.054688 33.554688 25.03125 33.570312 25.003906 33.585938 C 24.976562 33.597656 24.945312 33.613281 24.882812 33.636719 L 14.21875 37.976562 C 14.136719 38.007812 14.097656 38.027344 14.054688 38.039062 C 14.019531 38.046875 13.980469 38.054688 13.945312 38.058594 C 13.902344 38.066406 13.859375 38.066406 13.769531 38.070312 Z M 5.164062 38.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,66.666669%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 8.628906 50 L 45.996094 34.824219 L 33.601562 43.300781 C 33.558594 43.332031 33.535156 43.347656 33.511719 43.359375 C 33.492188 43.371094 33.472656 43.382812 33.449219 43.394531 C 33.425781 43.40625 33.402344 43.414062 33.351562 43.4375 L 19.753906 48.96875 C 19.691406 48.996094 19.660156 49.007812 19.625 49.019531 C 19.597656 49.027344 19.566406 49.035156 19.535156 49.039062 C 19.5 49.046875 19.464844 49.050781 19.398438 49.054688 Z M 8.628906 50 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherLogo);
export default __webpack_public_path__ + "static/media/ether_logo.7758f5da7ca8516f864089a9c5eff1d0.svg";
export { ForwardRef as ReactComponent };